// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scalebar_root_VnNgt {
  display: flex;
  flex-flow: column;
  align-items: center;
}

.scalebar_root_VnNgt > *:first-child {
  margin: 5px 0;
  font-family: GothamRounded-Medium;
  color: black;
  text-shadow: 0px 0px 1px rgba(255, 255, 255, 1), 0px 0px 1px rgba(255, 255, 255, 1),
    0px 0px 1px rgba(255, 255, 255, 1);
}

.scalebar_root_VnNgt > *:last-child {
  height: 10px;
  background: repeating-linear-gradient(90deg, black, black 25%, white 25%, white 50%);
  border: 1px solid white;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/components/map/scalebar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,YAAY;EACZ;sCACoC;AACtC;;AAEA;EACE,YAAY;EACZ,oFAAoF;EACpF,uBAAuB;EACvB,sBAAsB;AACxB","sourcesContent":[".root {\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n}\n\n.root > *:first-child {\n  margin: 5px 0;\n  font-family: GothamRounded-Medium;\n  color: black;\n  text-shadow: 0px 0px 1px rgba(255, 255, 255, 1), 0px 0px 1px rgba(255, 255, 255, 1),\n    0px 0px 1px rgba(255, 255, 255, 1);\n}\n\n.root > *:last-child {\n  height: 10px;\n  background: repeating-linear-gradient(90deg, black, black 25%, white 25%, white 50%);\n  border: 1px solid white;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `scalebar_root_VnNgt`
};
module.exports = ___CSS_LOADER_EXPORT___;
